'use client'
import React from 'react'

import { ISeminarAppContext, SeminarAppContext } from './SeminarAppContext'

export const SeminarAppContextProvider = ({
  children,
  isSeminar,
  isSeminarSearchEnabled,
}: {
  children: React.ReactNode
  isSeminar: boolean
  isSeminarSearchEnabled: boolean
}) => {
  const context: ISeminarAppContext = {
    isSeminar,
    isSeminarSearchEnabled,
  }

  return (
    <SeminarAppContext.Provider value={context}>
      {children}
    </SeminarAppContext.Provider>
  )
}
